export const testIds = {
    portal: {
        base: 'portal',
        trigger: 'portal_trigger',
        children: 'portal_children',
    },
    badge: {
        base: 'badge',
        prefixIcon: 'badge_prefix_icon',
        suffixIcon: 'badge_suffix_icon',
        text: 'badge_text',
    },
    brand: {
        base: 'brand',
        size: 'brand_size',
    },
    button: {
        base: 'button',
        prefixIcon: 'button_prefix_icon',
        suffixIcon: 'button_suffix_icon',
        spinner: 'button_spinner',
        text: 'button_text',
    },
    breadcrumb: {
        base: 'breadcrumb',
        link: 'breadcrumb_link',
        homeLink: 'breadcrumb_home_link',
        homeIcon: 'breadcrumb_home_icon',
        separatorText: 'breadcrumb_separator_text',
        separatorIcon: 'breadcrumb_separator_icon',
    },
    ColorPicker: {
        base: 'color_picker',
        stack: 'color_picker_stack',
        label: 'color_picker_label',
        colorDiv: 'color_picker_color_div',
        menuLabel: 'color_picker_menu_label',
        hexCodeLabel: 'color_picker_hex_code_label',
        input: 'color_picker_input',
        spinner: 'color_picker_spinner',
        prefixIcon: 'color_picker_prefix_icon',
        prefixText: 'color_picker_prefix_text',
        suffixIcon: 'color_picker_suffix_icon',
        suffixText: 'color_picker_suffix_text',
        pickerButton: 'color_picker_picker_button',
        hexColorPicker: 'color_picker_hex_color_picker',
        pickerButtonText: 'color_picker_picker_button_text',
        pickerButtonPlaceholder: 'color_picker_picker_button_placeholder',
        errorMessage: 'color_picker_error_message',
        validationError: 'color_picker_validation_error',
        clearButton: 'color-picker-clear-button',
        colorSlider: 'color-picker-color-slider',
        hexCodeInput: 'color-picker-hex-code-input',
    },
    confirmationDialog: {
        base: 'confirmation_dialog',
        messageText: 'confirmation_dialog_message_text',
        primaryButton: 'confirmation_dialog_primary_button',
        secondaryButton: 'confirmation_dialog_secondary_button',
    },
    drawer: {
        base: 'drawer',
        closeButton: 'drawer_close_button',
        title: 'drawer_title',
        icon: 'drawer_icon',
    },
    grid: {
        base: 'grid',
    },
    stack: {
        base: 'stack',
    },
    hStack: {
        base: 'h_stack',
    },
    vStack: {
        base: 'v_stack',
    },
    card: {
        base: 'card',
        tagline: 'card_tagline',
        title: 'card_title',
        subtitle: 'card_subtitle',
        icon: 'card_icon',
    },
    container: {
        base: 'container',
    },
    divider: {
        base: 'divider',
    },
    emptyPlaceholder: {
        base: 'empty_placeholder',
        icon: 'empty_placeholder_icon',
        textTitle: 'empty_placeholder_text_title',
        textMessage: 'empty_placeholder_text_message',
    },
    icon: {
        base: 'icon',
    },
    iconBox: {
        base: 'icon_box',
        icon: 'icon_box_icon',
    },
    link: {
        base: 'link',
        text: 'link_text',
        loadingText: 'link_loading_text',
        prefixIcon: 'link_prefix_icon',
        suffixIcon: 'link_suffix_icon',
        spinner: 'link_spinner',
    },
    spinner: {
        base: 'spinner',
        icon: 'spinner_icon',
    },
    tabs: {
        base: 'tabs',
        label: 'tabs_label',
        grid: 'tabs_grid',
        option: 'tabs_option',
        text: 'tabs_text',
    },
    text: {
        base: 'text',
    },
    infoBox: {
        base: 'info_box',
        title: 'info_box_title',
        info: 'info_box_info',
        icon: 'info_box_icon',
    },
    dialog: {
        base: 'dialog',
        container: 'dialog_container',
        titleText: 'dialog_title_text',
        closeIcon: 'dialog_close_icon',
        titleBox: 'dialog_title_box',
        closeButton: 'dialog_close_button',
        childrenBox: 'dialog_children_box',
    },
    navigationTabs: {
        base: 'navigation_tabs',
    },
    image: {
        base: 'image',
        image: 'image_image',
    },
    formActions: {
        base: 'form_actions_footer',
        text: 'form_actions_footer_text',
        link: 'form_actions_footer_link',
        primaryButton: 'form_actions_primary_button',
        secondaryButton: 'form_actions_secondary_button',
        secondaryLink: 'form_actions_secondary_link',
    },
    table: {
        base: 'table',
        table: 'table_table',
    },
    tableHead: {
        base: 'table_head',
        selectionColumn: 'table_head_selection_column',
        column: 'table_head_column',
        actionsColumn: 'table_head_actions_column',
        actionsColumnText: 'table_head_actions_column_text',
    },
    tableRow: {
        base: 'table_row',
        row: 'table_row_row',
    },
    themeSwitcher: {
        base: 'theme_switcher',
    },
    tableData: {
        base: 'table_data',
        primaryText: 'table_data_primary_text',
        secondaryText: 'table_data_secondary_text',
        stack: 'table_data_stack',
        thumbnail: 'table_data_thumbnail',
    },
    label: {
        base: 'label',
        icon: 'label_icon',
        text: 'label_text',
    },
    gradientBox: {
        base: 'gradient_box',
        textBox: 'gradient_box_text',
        primaryText: 'gradient_box_primary_text',
        secondaryText: 'gradient_box_secondary_text',
    },
    loader: {
        base: 'loader',
        textTitle: 'loader_text_title',
        textMessage: 'loader_text_message',
    },
    colorBox: {
        base: 'color_box',
        textBox: 'color_box_text',
    },
    collapsible: {
        base: 'collapsible',
        button: 'collapsible_button',
    },
    slideDown: {
        base: 'slide_down',
    },
    languageSwitcher: {
        base: 'language_switcher',
        button: 'language_switcher_button',
        text: 'language_switcher_text',
    },
    avatar: {
        base: 'avatar',
        image: 'avatar_image',
        indicator: 'avatar_indicator',
    },
    accordion: {
        base: 'accordion',
        collapsible: 'accordion_collapsible',
        text: 'accordion_text',
    },
    rating: {
        base: 'rating',
        icon: 'rating_icon',
    },
    checkBox: {
        base: 'checkbox',
        text: 'checkbox_text',
        iconBox: 'checkbox_icon_box',
        icon: 'checkbox_icon',
        footnote: 'checkbox_footnote',
    },
    checkboxGroup: {
        base: 'checkbox_group',
    },
    numberInput: {
        base: 'number_input',
        prefix: 'number_input_prefix',
        suffix: 'number_input_suffix',
        numericFormat: 'number_input_numeric_format',
        text: 'number_input_text',
        icon: 'number_input_icon',
        hStack: 'number_input_h_stack',
        spinner: 'number_input_spinner',
    },
    otpInput: {
        base: 'otp_input',
        errorMessage: 'otp_input_error_message',
        validationError: 'otp_input_validation_error',
        input: 'otp_input_input',
    },
    clientOnly: {
        base: 'client_only',
    },
    statisticsCard: {
        base: 'statistics_card',
        title: 'statistics_card_title',
        icon: 'statistics_card_icon',
        info: 'statistics_card_info',
        subtitle: 'statistics_card_subtitle',
    },
    dataRenderer: {
        base: 'data_renderer',
        data: 'data_renderer_data',
    },
    switcher: {
        base: 'switcher',
        switch: 'switcher_switch',
        label: 'switcher_label',
        subtitle: 'switcher_subtitle',
        span: 'switcher_span',
    },
    maskInput: {
        base: 'mask_input',
        label: 'mask_input_label',
        stack: 'mask_input_stack',
        prefix: 'mask_input_prefix',
        suffix: 'mask_input_suffix',
        input: 'mask_input_input',
        spinner: 'mask_input_spinner',
        inputIcon: 'mask_input_input_icon',
        errorText: 'mask_input_error_text',
        validationError: 'mask_input_validation_error',
    },
    devOnly: {
        base: 'dev_only',
    },
    progressBar: {
        base: 'progress_bar',
        bar: 'progress_bar_bar',
        text: 'progress_bar_text',
    },
    progressCircle: {
        base: 'progress_circle',
        text: 'progress_circle_text',
    },
    inputAffix: {
        base: 'input_affix',
        icon: 'input_affix_icon',
        text: 'input_affix_text',
    },
    searchInput: {
        base: 'search_input',
    },
    select: {
        base: 'select',
        label: 'select_label',
        stack: 'select_stack',
        prefixIcon: 'select_prefix_icon',
        prefixIconStack: 'select_prefix_icon_stack',
        prefixText: 'select_prefix_text',
        prefixTextStack: 'select_prefix_text_stack',
        suffixIcon: 'select_suffix_icon',
        suffixIconStack: 'select_suffix_icon_stack',
        suffixText: 'select_suffix_text',
        suffixTextStack: 'select_suffix_text_stack',
        input: 'select_input',
        spinner: 'select_spinner',
        inputIcon: 'select_input_icon',
        errorText: 'select_error_text',
        validationError: 'select_validation_error',
    },
    tagsInput: {
        base: 'tags_input',
        input: 'tags_input_input',
        tag: 'tags_input_tag',
        tagText: 'tags_input_tag_text',
        tagCloseIcon: 'tags_input_tag_close_icon',
        tagCloseButton: 'tags_input_tag_close_button',
        label: 'tags_input_label',
        name: 'tags_input_name',
        placeholder: 'tags_input_placeholder',
        text: 'tags_input_Text',
    },
    textInput: {
        base: 'text_input',
        name: 'text_input_name',
        placeholder: 'text_input_placeholder',
        label: 'text_input_label',
        text: 'text_input_Text',
        input: 'text_input_input',
        validationError: 'text_input_validation_error',
        errorMessage: 'text_input_error_message',
    },
    textarea: {
        base: 'textarea',
        textAreaContainer: 'textarea_container',
        prefixIcon: 'textarea_prefix_icon',
        validationError: 'textarea_validation_error',
    },
    pagination: {
        base: 'pagination',
        button: 'pagination_button',
        text: 'pagination_text',
        icon: 'pagination_icon',
    },
    menu: {
        base: 'menu',
        item: 'menu_item',
        button: 'menu_button',
    },
    datePicker: {
        base: 'date_picker',
        input: 'date_picker_input',
        prefix: 'date_picker_prefix_icon',
        suffix: 'date_picker_suffix_icon',
        validationError: 'date_picker_validation_error',
        hStack: 'date_picker_h_stack',
    },
    timePicker: {
        base: 'time_picker',
        input: 'time_picker_input',
        prefix: 'time_picker_prefix_icon',
        suffix: 'time_picker_suffix_icon',
        validationError: 'time_picker_validation_error',
        hStack: 'time_picker_h_stack',
    },
    radioGroup: {
        base: 'radio_group',
    },
    view: {
        base: 'view',
    },
    alert: {
        base: 'alert',
        icon: 'alert_icon',
        title: 'alert_title',
        message: 'alert_message',
        textSize: 'text_size',
        button: 'alert_button',
    },
};
